import {
  ref,
  computed,
  provide,
} from 'vue';

export function useUnidadImposicionProvider(localModel) {
  const unidadImposicionLocal = ref((localModel.value?.UnidadMedida || 'mm').toLowerCase());

  const unidadImposicion = computed(() => unidadImposicionLocal.value);

  const onUnidadImposicionChange = (val) => {
    unidadImposicionLocal.value = (val || 'mm').toLowerCase();
  };

  provide('unidadImposicion', unidadImposicion);

  return {
    unidadImposicion,
    unidadImposicionLocal,
    onUnidadImposicionChange,
  };
}
